var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"image-text-content",style:({
    'background-color': _vm.content.background,
    color: _vm.content.text_color || 'white'
  }),attrs:{"type":"flex","justify":"center"}},[_c('vs-col',{staticClass:"text--html",attrs:{"lg":"10","sm":"11","xs":"12","justify":"left"}},[_c('InternalHTMLTextContent',{attrs:{"html":_vm.content.body}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }